import React, {useEffect, useRef, useState} from 'react';
import './ModalFormFeedback.scss';
import './ModalFormFeedback-media.scss';
import {ValidationFormItems, bodyAuto, bodyHidden} from '../../services/GlobalFunctions';
import Input from '../Input/Input';
import InputPhone from '../Input/InputPhone';
import Button from '../Button/Button';
import ErrorText from '../ErrorText/ErrorText';
import {ServiceData} from '../../redux/services/ServiceRedux';
import {Props} from './interfaces';
import {connect, WithStore, MapStateToProps, MapDispatchToProps} from '../../redux/services/Imports';
import {EnumUrlsPages} from '../../services/Enum';
import Textarea from '../Textarea/Textarea';
import {useSmartCaptcha} from '../SmartCaptcha/useSmartCaptcha';
import SmartCaptchaBox from '../SmartCaptcha/SmartCaptchaBox';
import {GetNameTitle} from '../../redux/services/GlobalFunctions';
import {ISelectItemWithEventMetrika} from '../../services/Interfaces';
import {CSSTransition} from 'react-transition-group';
import SelectCust from '../SelectCust/SelectCust';
import SuccessContent from '../SuccessContent/SuccessContent';
import {getPrivacyPolicyText} from "../../services/content/functions";
import {content} from "../../services/content";
import {METRIKA_ASK_QUESTION_FORM} from "../../services/content/Constants";
import AgreementCheckboxes from "../AgreementCheckboxes/AgreementCheckboxes";

declare const ym: any;
declare const _tmr: any;

const ModalFormFeedback = ({
                             title,
                             buttonText = 'Отправить',
                             closedModal,
                             select,
                             id,
                             blockedSend,
                             blockedSendLoaded,
                             eventMetrika = '',
                             sendAmoCRM = false,
                             hasCssTransition = false,
                             showForm = false,
                             recaptchaV2ref,
                             phoneNumber = '+7',
                             contactForms,
                             initialAllowMarketing = true
                           }: Props) => {

  console.debug('modal form feedback contactForms', contactForms);

  useEffect(() => {
    if (showForm) {
      bodyHidden();
      return;
    }
    bodyAuto();
  }, [showForm]);

  useEffect(() => {
    setPhone(phoneNumber);
  }, [phoneNumber]);

  const [name, setName] = useState('');
  const [phone, setPhone] = useState(phoneNumber);
  const [email, setEmail] = useState('');
  const [errorPhone, setErrorPhone] = useState<string | null>(null);
  const [errorEmail, setErrorEmail] = useState<string | null>(null);
  const [serverText, setServerText] = useState<string | null>(null);
  const showEmail = !!contactForms?.show_email;
  const [successShow, setSuccessShow] = useState(false);
  const [disableBtn, setDisableBtn] = useState(false);
  const [showBlockedError, setShowBlockedError] = useState(false);
  const [privacyPolicyAccepted, setPrivacyPolicyAccepted] = useState(false);
  const [allowMarketing, setAllowMarketing] = useState(initialAllowMarketing);
  const [privacyErrorCount, setPrivacyErrorCount] = useState(0);

  const success = () => {
    setName('');
    setPhone('');
    setEmail('');
    setMsg('');
    setOrderNumber('');
    setCompany('');
    setCity('');
    captcha.reset();
    setSuccessShow(true);
    // Fire metrika goal only for "Сотрудничество" (value === 1), not for "Вопрос по заказу"
    if (typeof ym !== 'undefined' && selectValue && selectValue.value === 1) {
      ym(26501373, 'reachGoal', 'feedback_success');
    }
    if (typeof _tmr !== 'undefined' && selectValue && selectValue.value === 1) {
      _tmr.push({ type: 'reachGoal', id: 3737442, goal: 'vkamolead'});
    }
    setDisableBtn(false);
    setPrivacyPolicyAccepted(false);
    setAllowMarketing(true);
    setPrivacyErrorCount(0);
  };

  const ClosedModal = () => {
    setSuccessShow(false);
    closedModal();
  };

  const [msg, setMsg] = useState('');
  const [errorMsg, setErrorMsg] = useState<string | null>(null);
  const [hasTextarea, setHasTextarea] = useState(false);

  const [orderNumber, setOrderNumber] = useState('');
  const [errorNumOrder, setErrorNumOrder] = useState<string | null>(null);
  const [hasOrderNumber, setHasOrderNumber] = useState(false);

  const [company, setCompany] = useState('');
  const [hasCompany, setHasCompany] = useState(false);
  const [city, setCity] = useState('');
  const [hasCity, setHasCity] = useState(false);

  const [errorTheme, setErrorTheme] = useState<string | null>(null);

  const captcha = useSmartCaptcha(contactForms);

  const handleReCaptchaVerify = async (e: any) => {
    e.preventDefault();
    console.log('handle recaptcha verify');

    if (!privacyPolicyAccepted) {
      setPrivacyErrorCount(c => c + 1);
      return;
    }

    setDisableBtn(true);

    setShowBlockedError(false);
    if (blockedSend.state) {
      setShowBlockedError(true);
      setDisableBtn(false);
      return;
    }

    setErrorTheme(null);
    if (!selectValue) {
      setErrorTheme('Выбор темы обязателен');
      setDisableBtn(false);
      return;
    }

    if (
      !ValidationFormItems({
        fields: cooperation ? [] : [orderNumber, msg],
        arrSetError: cooperation ? [] : [setErrorNumOrder, setErrorMsg],
        phone,
        setErrorPhone,
        email,
        setErrorEmail,
        requireEmail: showEmail,
      })
    ) {
      setDisableBtn(false);
      return;
    }

    // Капча требуется только для "Сотрудничество" (форма 6).
    // Для "Вопрос по заказу" (форма 774) капча не нужна.
    let token = '';
    if (cooperation) {
      try {
        token = await captcha.ensureToken();
      } catch {
        setDisableBtn(false);
        return;
      }
    }

    ServiceData.sendEmailContacts({
      data: {
        name,
        phone,
        department: selectValue ? selectValue.value : 0,
        orderNumber: hasOrderNumber ? orderNumber : '-',
        msg: hasTextarea ? msg : `Название компании - ${company}, Город - ${city}`,
        page: GetNameTitle({eventMetrika: evMetrika}),
        allowMarketing: allowMarketing,
        ...(showEmail ? { email } : {}),
      },
      token,
      setServerText: (t: string) => { setServerText(t); captcha.reset(); setDisableBtn(false); },
      success,
      blockedSendLoaded,
      eventMetrika: evMetrika,
      contactFormId: evMetrika === METRIKA_ASK_QUESTION_FORM ? contactForms.ask_question_contact_form_id : contactForms.modal_contact_form_id
    });
  };

  const selectOptions = select ? select.options : [];
  const [selectValue, setSelectValue] = useState<ISelectItemWithEventMetrika>(
    select && select.active ? select.active : selectOptions[-1]
  );
  const [evMetrika, setEvMetrika] = useState(eventMetrika);

  const complaint = selectValue && selectValue.value === 0;
  const cooperation = selectValue && selectValue.value === 1;

  useEffect(() => {
    if (select) {
      setEvMetrika(selectValue?.eventMetrika || eventMetrika);
      setHasOrderNumber(complaint);
      setHasTextarea(complaint);
      setHasCompany(cooperation);
      setHasCity(cooperation);
      // Сброс капчи при смене темы (токен одноразовый, виджет монтируется только для "Сотрудничество").
      captcha.reset();
    }
  }, [selectValue]);

  const nodeRef = useRef(null);
  const nodeRefSuccess = useRef(null);
  const form = (
    <div className="modal-container">
      <div
        ref={nodeRef}
        className={`modal-form-feedback${successShow ? ' modal-form-feedback_success' : ''}`}
      >
        <div className="modal-form-feedback__close" onClick={ClosedModal}></div>

        <CSSTransition
          in={successShow}
          nodeRef={nodeRefSuccess}
          timeout={{appear: 200, enter: 0, exit: 200}}
          classNames="css-transition-modal"
          unmountOnExit
        >
          <SuccessContent refCss={nodeRefSuccess} socs/>
        </CSSTransition>

        {!successShow && (
          <form id={id || ''} className="modal-form-feedback__form" onSubmit={handleReCaptchaVerify}>
            <h2 className="modal-form-feedback__title">{title}</h2>

            {select && !select.disabled ? (
              <SelectCust
                options={selectOptions}
                placeholder={content.modalForm.chooseTopic}
                value={selectValue}
                setSelectValue={setSelectValue}
                error={errorTheme}
              />
            ) : null}

            <Input
              label={content.formContacts.inputName}
              name="name"
              value={name}
              focus
              onChange={(e: any) => setName(e.target.value)}
              error={null}
              marginTop={24}
            />
            <InputPhone
              label={content.formContacts.inputPhone}
              name="phone"
              value={phone}
              onChange={(e: any) => setPhone(e.target.value)}
              error={errorPhone}
              marginTop={24}
            />
            {showEmail && (
              <Input
                type="email"
                label={content.formContacts.inputEmail}
                name="your-email"
                value={email}
                onChange={(e: any) => setEmail(e.target.value)}
                error={errorEmail}
                marginTop={24}
              />
            )}

            {hasCompany && (
              <Input
                label={content.formContacts.inputCompanyName}
                name="company"
                value={company}
                onChange={(e: any) => setCompany(e.target.value)}
                marginTop={24}
              />
            )}

            {hasCity && (
              <Input
                label={content.formContacts.inputCity}
                name="city"
                value={city}
                onChange={(e: any) => setCity(e.target.value)}
                marginTop={24}
              />
            )}

            {hasOrderNumber && (
              <Input
                label={content.formContacts.inputOrderNr + '*'}
                name="orderNumber"
                value={orderNumber}
                focus
                onChange={(e: any) => setOrderNumber(e.target.value)}
                error={errorNumOrder}
                marginTop={24}
              />
            )}

            {hasTextarea && (
              <Textarea
                label={content.formContacts.inputReason}
                value={msg}
                onChange={(e: any) => setMsg(e.target.value)}
                error={errorMsg}
                marginTop="24px"
              />
            )}

            {cooperation && <SmartCaptchaBox captcha={captcha} />}

            <div className="modal-form-feedback__button">
              <Button text={buttonText} widthAll disabled={disableBtn}
                      showBlockedError={showBlockedError}/>
              {serverText ? ErrorText(serverText) : null}
            </div>

            <AgreementCheckboxes privacyChecked={privacyPolicyAccepted}
                                 onPrivacyChange={(checked) => {
                                   setPrivacyPolicyAccepted(checked);
                                   if (checked) setPrivacyErrorCount(0);
                                 }}
                                 marketingChecked={allowMarketing}
                                 onMarketingChange={setAllowMarketing}
                                 errorTrigger={privacyErrorCount}/>
          </form>
        )}
      </div>
      <div className="modal-bg" onClick={ClosedModal}></div>
    </div>
  );

  return hasCssTransition ? (
    <CSSTransition
      in={showForm}
      nodeRef={nodeRef}
      timeout={{appear: 200, enter: 0, exit: 200}}
      classNames="css-transition-modal"
      unmountOnExit
    >
      {form}
    </CSSTransition>
  ) : showForm ? (
    form
  ) : null;
};

// Custom mergeProps to let ownProps override stateProps (fixes contactForms from Header being overwritten by Redux defaults)
const mergeProps = (stateProps: any, dispatchProps: any, ownProps: any) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
});

export default WithStore()(connect(MapStateToProps, MapDispatchToProps, mergeProps)(ModalFormFeedback));
